
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "PremenstrualDysphoricDisorderDiagnosticCriteria",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/ObGyn/PremenstrualDysphoricDisorderDiagnosticCriteria.vue